import { baseCrudFactory } from "~/stores/base.crud.store.ts"
import { Api } from "~/api/Api.ts"

export const useTemplateStore = baseCrudFactory({
    endpoint: "/",
    primaryKey: "id",
    title: "",
    modules: {
        resource: () => useResourceStore(),
    },
    actions: {},
    getters: {},
})
